import type { MemePreset } from '../types';

export const MEME_PRESETS: MemePreset[] = [
  { id: 'square', name: 'Square (Instagram)', width: 1080, height: 1080 },
  { id: 'landscape', name: 'Landscape (Twitter)', width: 1200, height: 675 },
  { id: 'portrait', name: 'Portrait (Story)', width: 1080, height: 1920 },
  { id: 'classic', name: 'Classic Meme', width: 800, height: 800 },
  { id: 'custom', name: 'Custom', width: 1000, height: 1000 },
];

export const DEFAULT_MEME_PRESET = MEME_PRESETS[0];

export const MIN_MEME_DIMENSION = 100;
export const MAX_MEME_DIMENSION = 4096;

export const MEME_FONTS = [
  'Impact',
  'Arial Black',
  'Comic Sans MS',
  'Helvetica',
  'Arial',
  'Verdana',
];
